/**
 * SEO for the forgot-password route (`/auth/forgot-password`).
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { absoluteUrlForPath } from '@web/src/lib/utilsClient'

export type ForgotPasswordPageSeoLoaderInput = Record<string, never>

export function forgotPasswordPageHeadFromLoaderData(
  _loaderData?: ForgotPasswordPageSeoLoaderInput | null | undefined
) {
  const pageUrl = absoluteUrlForPath('/auth/forgot-password')
  const description =
    'Request a password reset link for Spicy Friends. We email a time-limited link—use your profile email and check spam folders if it is delayed.'

  return seo({
    title: `Forgot password — reset link | ${env.VITE_APP_NAME}`,
    description,
    url: pageUrl,
    robots: robotsMetaForEnvironment({
      production: 'index, follow',
      staging: 'noindex,nofollow',
    }),
  })
}
